module.exports = __webpack_public_path__ + "img/P6.9ca7cd30.jpg";